module.exports = __webpack_public_path__ + "img/Address-Info.b69676e0.svg";